import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable()
export class AloeAroundTheworldService {

  constructor(private _http: HttpClient) { }

  /**
   * @description
   * @date 2019-05-20
   * @returns {Observable<any>}
   * @memberof AloeAroundTheworldService
   */
  public getTopFBOByCountries(): Observable<any> {
    // const topCountriesURI = environment.uiTemplateBaseUrl + '/test/top-country.json';
    const topCountriesURI = ApiUrlConstants.reportsApiURL + '/summerpromotion-topfbos-bycountry?month=7&year=2019';

    return this._http
      .get(topCountriesURI)
      .pipe(catchError(this.handleErrorObservable));
    // .map((res: Response) => res.json())
    // .catch(this.handleErrorObservable);
  }

  /**
   * @description
   * @date 2019-05-20
   * @returns {Observable<any>}
   * @memberof AloeAroundTheworldService
   */
  getTopTeams(): Observable<any> {
    // const topTeamsURI = environment.uiTemplateBaseUrl + '/test/top-team.json';
    const topTeamsURI = ApiUrlConstants.reportsApiURL + '/summerpromotion-topteams';
    return this._http
      .get(topTeamsURI)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description
   * @date 2019-05-21
   * @returns {Observable<any>}
   * @memberof AloeAroundTheworldService
   */
  getTierCountries(): Observable<any> {
    const tierCountriesURI = environment.uiTemplateBaseUrl + '/test/tier-level-countries.json';
    return this._http
      .get(tierCountriesURI)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description
   * @date 2019-05-20
   * @param {number} countryId
   * @returns {Observable<any>}
   * @memberof AloeAroundTheworldService
   */
  getTopFBO(countryCode: string): Observable<any> {
    // const topFboURI = environment.uiTemplateBaseUrl + '/test/top-fbo.json';
    const topFboURI = ApiUrlConstants.reportsApiURL + '/summerpromotion-topfbos?countryCode=' + countryCode;
    return this._http
      .get(topFboURI)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
   * @description To Get Countries By Regions
   * @author njagadeesan
   * @date 2019-12-12
   * @returns {Observable<any>}
   * @memberof AloeAroundTheworldService
   */
  public getCountriesByRegions(): Observable<any> {
    const regionsURL = ApiUrlConstants.reportsApiURL + '/countries-by-regions';
    return this._http
      .get(regionsURL)
      .pipe(catchError(this.handleErrorObservable));
  }

  public getTopFBOsByCountry(countryCode: string): Observable<any> {
    const regionsURL = ApiUrlConstants.reportsApiURL + '/summerpromotion-topfbos-bycountry?operatingCompanyCode=' + countryCode;
    return this._http
      .get(regionsURL)
      .pipe(catchError(this.handleErrorObservable));
  }

  /**
  * To handle the obervable error response
  * @param  {Response|any} error
  */
  /**
    * To handle the obervable error response
    * @param err 
    */
  private handleErrorObservable(err) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }


}
